import React, { useEffect, useState } from "react";
import { filter, startsWith } from "lodash";
import TagsListVertical from "cube-components/blog/TagsListVertical";

const filterTagsFunction = (tags: string[], searchPhrase: string) => {
  return filter(tags, element => startsWith(element, searchPhrase));
};

export interface TagsFilterProps {
  tags: string[];
}

const TagsFilter = ({ tags }: TagsFilterProps) => {
  const [filteredTags, setFilteredTags] = useState(tags);
  const [searchPhrase, setSearchPhrase] = useState("");

  useEffect(() => {
    const filtered = filterTagsFunction(tags, searchPhrase);
    setFilteredTags(filtered);
  }, [tags, searchPhrase]);

  const handleSearchInput = (e: React.KeyboardEvent<HTMLInputElement>) => {
    let phrase = (e.target as HTMLInputElement).value;
    phrase = phrase.trim().toLocaleLowerCase();
    setSearchPhrase(phrase);
  };

  return (
    <div className="my-10 pb-10">
      <div className="">
        <input
          className="
          ml-auto
          block
          text-xl
          border-4
          border-b-0
          text-center
          border-lucid-700
          text-lucid-900
          shadow-inner
          shadow-gray-400
          rounded-t-xl py-5"
          name="tags-search"
          type="text"
          placeholder="Search for tags"
          onKeyUp={handleSearchInput}
        ></input>
      </div>
      <TagsListVertical tags={filteredTags} />
    </div>
  );
};

export default TagsFilter;
